import { render, staticRenderFns } from "./passwordLogin.vue?vue&type=template&id=fd6c5028&scoped=true"
import script from "./passwordLogin.vue?vue&type=script&lang=js"
export * from "./passwordLogin.vue?vue&type=script&lang=js"
import style0 from "./passwordLogin.vue?vue&type=style&index=0&id=fd6c5028&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6c5028",
  null
  
)

export default component.exports